//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavDashboard(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.85 4L10.57 13H4V6H2V22H22V2H2V4H13.85ZM4 15H9.84L8 20H4V15ZM10.15 20L13.43 11H20V20H10.15ZM20 9H14.16L15.98 4H19.98L20 9Z" fill="currentColor" /></svg>;
}
export default IconNavDashboard;